/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

export { default as Add } from './components/add.js';
export { default as AddCircle } from './components/add_circle.js';
export { default as Arrow } from './components/arrow.js';
export { default as ArrowDown } from './components/arrow_down.js';
export { default as ArrowLeft } from './components/arrow_left.js';
export { default as ArrowRight } from './components/arrow_right.js';
export { default as ArrowUp } from './components/arrow_up.js';
export { default as Calendar } from './components/calendar.js';
export { default as Call } from './components/call.js';
export { default as ChatSettings } from './components/chat_settings.js';
export { default as Check } from './components/check.js';
export { default as CheckCircle } from './components/check_circle.js';
export { default as CheckFilled } from './components/check_filled.js';
export { default as ClosCircle } from './components/clos_circle.js';
export { default as Close } from './components/close.js';
export { default as CloseFilled } from './components/close_filled.js';
export { default as Complaint } from './components/complaint.js';
export { default as Computer } from './components/computer.js';
export { default as Contact } from './components/contact.js';
export { default as Copy } from './components/copy.js';
export { default as Crop } from './components/crop.js';
export { default as Delete } from './components/delete.js';
export { default as Download } from './components/download.js';
export { default as Edit } from './components/edit.js';
export { default as Emoji } from './components/emoji.js';
export { default as Esc } from './components/esc.js';
export { default as Female } from './components/female.js';
export { default as Floder } from './components/floder.js';
export { default as Group } from './components/group.js';
export { default as Home } from './components/home.js';
export { default as Image } from './components/image.js';
export { default as InfoCircle } from './components/info_circle.js';
export { default as InfoFilled } from './components/info_filled.js';
export { default as Like } from './components/like.js';
export { default as Link } from './components/link.js';
export { default as List } from './components/list.js';
export { default as Location } from './components/location.js';
export { default as Mail } from './components/mail.js';
export { default as Male } from './components/male.js';
export { default as Maximize } from './components/maximize.js';
export { default as Message } from './components/message.js';
export { default as MicrophoneOff } from './components/microphone_off.js';
export { default as MicrophoneOn } from './components/microphone_on.js';
export { default as Minimize } from './components/minimize.js';
export { default as More } from './components/more.js';
export { default as Music } from './components/music.js';
export { default as Notice } from './components/notice.js';
export { default as Play } from './components/play.js';
export { default as Printer } from './components/printer.js';
export { default as Qrcode } from './components/qrcode.js';
export { default as QuestionCircle } from './components/question_circle.js';
export { default as QuestionFilled } from './components/question_filled.js';
export { default as Remark } from './components/remark.js';
export { default as Scan } from './components/scan.js';
export { default as Search } from './components/search.js';
export { default as Share } from './components/share.js';
export { default as Star } from './components/star.js';
export { default as Telephone } from './components/telephone.js';
export { default as Time } from './components/time.js';
export { default as Transfer } from './components/transfer.js';
export { default as Visible } from './components/visible.js';
export { default as Volume } from './components/volume.js';
export { default as VolumeOff } from './components/volume_off.js';
export { default as WarningCircle } from './components/warning_circle.js';
export { default as WarningFilled } from './components/warning_filled.js';
export { default as ZoomIn } from './components/zoom_in.js';
export { default as ZoomOut } from './components/zoom_out.js';
import 'vue';

const version = "1.0.1";

export { version };
